import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import * as en from '../../locales/en';
import * as lt from '../../locales/lt';
import * as currency from './currency.json';
import { displayConfig, translationsConfig } from '@config/constants';

i18n.use(initReactI18next).init({
  resources: {
    en: { ...en, currency },
    lt: { ...lt, currency },
  },
  lng: displayConfig.defaultLocale,
  fallbackLng: displayConfig.defaultLocale,

  // have a country namespace used around the full app
  ns: translationsConfig.defaultNS,
  defaultNS: translationsConfig.defaultNS[0],

  debug: true, // config.NODE_ENV === NodeEnvEnum.development,

  interpolation: {
    escapeValue: false, // not needed for react!!
  },

  returnObjects: true,

  react: {
    wait: true,
  },
});

export default i18n;
